export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "js/http-worker.c972e7e1.worker.js");
}
